import axiosInstance from "../../utils/config/config";

export const getAllGroups = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllGroupsRequest",
    });
    const { data } = await axiosInstance.get(`/group/getAllGroups`);
    dispatch({
      type: "getAllGroupsSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAllGroupsFailure",
      payload: true,
    });
  }
};
